import { useState } from "react";
import UploadUsers from "./UploadUsers";
import { BsUpload } from "react-icons/bs";

const UploadWrapper = ({ refetch }: any) => {
  const [isVisible, setVisible] = useState(false);

  return (
    <>
      <button
        onClick={() => setVisible(true)}
        className="border rounded-md px-2 py-1 mx-1 flex items-center"
      >
        <BsUpload />
        <span className="ml-2">Upload</span>
      </button>
      <UploadUsers
        isVisible={isVisible}
        setVisible={setVisible}
        refetch={refetch}
      />
    </>
  );
};

export default UploadWrapper;
